(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["caleo-birthstone-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('caleo-birthstone-fields')) {
    customElements.define('caleo-birthstone-fields', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || document;
        this.onChange = this.update.bind(this);
        this.section.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onChange);
      }

      readOptionValue(optionName) {
        if (!optionName) return '';
        const normalizedName = optionName.trim().toLowerCase();
        const controls = this.section.querySelectorAll('select[name], input[name], [data-option-name]');

        for (const control of controls) {
          const controlName = (control.getAttribute('name') || '').toLowerCase();
          const optionLabel = (control.dataset.optionName || '').trim().toLowerCase();
          const isMatchingOption = optionLabel === normalizedName
            || (controlName.startsWith('options[') && controlName.includes(normalizedName))
            || controlName.startsWith(`${normalizedName}-`);
          if (!isMatchingOption) continue;
          if (control.tagName === 'SELECT') return control.value;
          if (control.matches('input[type="radio"], input[type="checkbox"]')) {
            if (control.checked) return control.value;
            continue;
          }
          if (control.value) return control.value;
        }

        return '';
      }

      requestedCount() {
        if (this.dataset.mode === 'single') return 1;
        if (this.dataset.mode === 'pair') return 2;

        const optionValue = this.readOptionValue(this.dataset.countOption);
        const parsedCount = Number.parseInt(optionValue, 10);
        const fallbackCount = Number.parseInt(this.dataset.defaultCount, 10) || 1;
        const maxCount = Number.parseInt(this.dataset.maxCount, 10) || 10;
        return Math.min(Math.max(parsedCount || fallbackCount, 1), maxCount);
      }

      update() {
        const count = this.requestedCount();
        const fields = this.querySelectorAll('[data-personalization-field]');

        for (const field of fields) {
          const fieldIndex = Number.parseInt(field.dataset.fieldIndex, 10);
          const isVisible = fieldIndex <= count;
          const select = field.querySelector('select');
          field.hidden = !isVisible;
          select.disabled = !isVisible;
          select.required = isVisible;
          select.setAttribute('aria-required', isVisible ? 'true' : 'false');
        }

        const status = this.querySelector('[data-count-status]');
        if (status && this.dataset.mode === 'variable') {
          status.textContent = `${count} birthstone ${count === 1 ? 'selection' : 'selections'} required.`;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["caleo-engraving-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('caleo-engraving-fields')) {
    customElements.define('caleo-engraving-fields', class extends HTMLElement {
      connectedCallback() {
        this.message = this.querySelector('[data-engraving-message]');
        this.counter = this.querySelector('[data-character-count]');
        this.onInput = this.updateCount.bind(this);
        this.message?.addEventListener('input', this.onInput);
        this.updateCount();
      }

      disconnectedCallback() {
        this.message?.removeEventListener('input', this.onInput);
      }

      updateCount() {
        if (!this.message || !this.counter) return;
        const maxLength = Number.parseInt(this.dataset.maxLength, 10) || this.message.maxLength;
        this.counter.textContent = `${this.message.value.length} / ${maxLength} characters`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["caleo-engraving-input"] && !Shopify.designMode) return;
  try {
    class CaleoEngravingInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-engraving-input]');
      this.count = this.querySelector('[data-engraving-count]');
      this.handleInput = this.handleInput.bind(this);
      this.input?.addEventListener('input', this.handleInput);
      this.updateState();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.handleInput);
    }

    handleInput() {
      this.updateState();
    }

    updateState() {
      if (!this.input) return;

      const value = this.input.value;
      const hasOnlyWhitespace = value.length > 0 && value.trim().length === 0;
      this.input.setCustomValidity(hasOnlyWhitespace ? this.input.dataset.emptyMessage || '' : '');

      if (this.count) {
        this.count.textContent = `${value.length} / ${this.input.maxLength}`;
      }
    }
  }

  if (!customElements.get('caleo-engraving-input')) {
    customElements.define('caleo-engraving-input', CaleoEngravingInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["caleo-ring-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('caleo-ring-size-chart')) {
    class CaleoRingSizeChart extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-caleo-ring-size-open]');
        this.dialog = this.querySelector('[data-caleo-ring-size-dialog]');
        this.closeButton = this.querySelector('[data-caleo-ring-size-close]');

        if (!this.trigger || !this.dialog || !this.closeButton) return;

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDialogClick = this.handleDialogClick.bind(this);
        this.handleDialogClosed = this.handleDialogClosed.bind(this);

        this.trigger.addEventListener('click', this.handleOpen);
        this.closeButton.addEventListener('click', this.handleClose);
        this.dialog.addEventListener('click', this.handleDialogClick);
        this.dialog.addEventListener('close', this.handleDialogClosed);
      }

      disconnectedCallback() {
        if (!this.trigger || !this.dialog || !this.closeButton) return;

        this.trigger.removeEventListener('click', this.handleOpen);
        this.closeButton.removeEventListener('click', this.handleClose);
        this.dialog.removeEventListener('click', this.handleDialogClick);
        this.dialog.removeEventListener('close', this.handleDialogClosed);
      }

      handleOpen() {
        if (this.dialog.open) return;

        this.lastFocusedElement = document.activeElement;
        this.dialog.showModal();
        requestAnimationFrame(() => this.closeButton.focus());
      }

      handleClose() {
        if (this.dialog.open) this.dialog.close();
      }

      handleDialogClick(event) {
        if (event.target === this.dialog) this.dialog.close();
      }

      handleDialogClosed() {
        this.lastFocusedElement?.focus();
      }
    }

    customElements.define('caleo-ring-size-chart', CaleoRingSizeChart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["caleo-shipping-location"] && !Shopify.designMode) return;
  try {
    class CaleoShippingLocation extends HTMLElement {
    connectedCallback() {
      this.renderDispatchDate();
      this.renderCountryFlag();
    }

    renderDispatchDate() {
      const dateElement = this.querySelector('[data-caleo-ship-date]');
      if (!dateElement) return;

      const dispatchDays = Math.max(Number.parseInt(this.dataset.dispatchDays, 10) || 1, 1);
      const skipWeekends = this.dataset.skipWeekends === 'true';
      const dispatchDate = new Date();
      dispatchDate.setHours(12, 0, 0, 0);

      let addedDays = 0;
      while (addedDays < dispatchDays) {
        dispatchDate.setDate(dispatchDate.getDate() + 1);
        const dayOfWeek = dispatchDate.getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

        if (!skipWeekends || !isWeekend) addedDays += 1;
      }

      const locale = document.documentElement.lang || 'en';
      const formatter = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      });

      const year = dispatchDate.getFullYear();
      const month = String(dispatchDate.getMonth() + 1).padStart(2, '0');
      const day = String(dispatchDate.getDate()).padStart(2, '0');

      dateElement.dateTime = `${year}-${month}-${day}`;
      dateElement.textContent = formatter.format(dispatchDate);
    }

    renderCountryFlag() {
      const flagElement = this.querySelector('[data-caleo-country-flag]');
      const countryCode = (this.dataset.countryCode || '').toUpperCase();
      if (!flagElement || !/^[A-Z]{2}$/.test(countryCode)) return;

      flagElement.textContent = [...countryCode]
        .map((character) => String.fromCodePoint(127397 + character.charCodeAt(0)))
        .join('');
    }
  }

  if (!customElements.get('caleo-shipping-location')) {
    customElements.define('caleo-shipping-location', CaleoShippingLocation);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["caleo-text-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('caleo-text-fields')) {
    customElements.define('caleo-text-fields', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || document;
        this.onChange = this.update.bind(this);
        this.section.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onChange);
      }

      readOptionValue(optionName) {
        if (!optionName) return '';
        const normalizedName = optionName.trim().toLowerCase();
        const controls = this.section.querySelectorAll('select[name], input[name], [data-option-name]');

        for (const control of controls) {
          const controlName = (control.getAttribute('name') || '').toLowerCase();
          const optionLabel = (control.dataset.optionName || '').trim().toLowerCase();
          const isMatchingOption = optionLabel === normalizedName
            || (controlName.startsWith('options[') && controlName.includes(normalizedName))
            || controlName.startsWith(`${normalizedName}-`);
          if (!isMatchingOption) continue;
          if (control.tagName === 'SELECT') return control.value;
          if (control.matches('input[type="radio"], input[type="checkbox"]')) {
            if (control.checked) return control.value;
            continue;
          }
          if (control.value) return control.value;
        }

        return '';
      }

      isConditionMet() {
        const optionName = this.dataset.conditionOption;
        const requiredValue = (this.dataset.conditionValue || '').trim().toLowerCase();
        if (!optionName || !requiredValue) return true;

        const optionValue = this.readOptionValue(optionName).trim().toLowerCase();
        if (!optionValue) return this.dataset.fallbackVisible === 'true';
        return optionValue.includes(requiredValue);
      }

      requestedCount() {
        if (this.dataset.mode === 'single') return 1;
        if (this.dataset.mode === 'pair') return 2;

        const optionValue = this.readOptionValue(this.dataset.countOption);
        const parsedCount = Number.parseInt(optionValue, 10);
        const fallbackCount = Number.parseInt(this.dataset.defaultCount, 10) || 1;
        const maxCount = Number.parseInt(this.dataset.maxCount, 10) || 10;
        return Math.min(Math.max(parsedCount || fallbackCount, 1), maxCount);
      }

      update() {
        const blockIsVisible = this.isConditionMet();
        const count = this.requestedCount();
        const shouldRequire = this.dataset.required === 'true';
        this.hidden = !blockIsVisible;

        const fields = this.querySelectorAll('[data-personalization-field]');
        for (const field of fields) {
          const fieldIndex = Number.parseInt(field.dataset.fieldIndex, 10);
          const isVisible = blockIsVisible && fieldIndex <= count;
          const input = field.querySelector('input');
          field.hidden = !isVisible;
          input.disabled = !isVisible;
          input.required = isVisible && shouldRequire;
          input.setAttribute('aria-required', isVisible && shouldRequire ? 'true' : 'false');
        }

        const status = this.querySelector('[data-count-status]');
        if (status && blockIsVisible && this.dataset.mode === 'variable') {
          status.textContent = `${count} ${count === 1 ? 'entry' : 'entries'} required.`;
        } else if (status) {
          status.textContent = '';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["caleo-twist-personalization"] && !Shopify.designMode) return;
  try {
    class CaleoTwistPersonalization extends HTMLElement {
    connectedCallback() {
      this.nameInput = this.querySelector('[data-twist-name-input]');
      this.nameCount = this.querySelector('[data-twist-name-count]');
      this.handleNameInput = this.handleNameInput.bind(this);
      this.nameInput?.addEventListener('input', this.handleNameInput);
      this.updateNameState();
    }

    disconnectedCallback() {
      this.nameInput?.removeEventListener('input', this.handleNameInput);
    }

    handleNameInput() {
      this.updateNameState();
    }

    updateNameState() {
      if (!this.nameInput) return;

      const value = this.nameInput.value;
      const hasOnlyWhitespace = value.length > 0 && value.trim().length === 0;
      this.nameInput.setCustomValidity(hasOnlyWhitespace ? this.nameInput.dataset.emptyMessage || '' : '');

      if (this.nameCount) {
        this.nameCount.textContent = `${value.length} / ${this.nameInput.maxLength}`;
      }
    }
  }

  if (!customElements.get('caleo-twist-personalization')) {
    customElements.define('caleo-twist-personalization', CaleoTwistPersonalization);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pg-builder"] && !Shopify.designMode) return;
  try {
    class PearlGraceBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.copy = this.config.settings;
      this.variants = this.config.variants;
      const first = this.variants.find(v => v.id === this.config.selectedId && v.available) || this.variants.find(v => v.available);
      if (!first) return;
      this.quantity = Number(this.querySelector('[data-quantity]:checked').value);
      this.choices = Array(6).fill(first);
      this.addons = new Map();
      this.selected = new Map();
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:this.config.currency });
      this.querySelectorAll('[data-card]').forEach(card => {
        const data = JSON.parse(card.querySelector('[data-addon]').textContent);
        this.addons.set(String(data.id), data);
      });
      this.abort = new AbortController();
      this.addEventListener('click', event => this.click(event), {signal:this.abort.signal});
      this.addEventListener('change', event => this.change(event), {signal:this.abort.signal});
      this.addEventListener('toggle', event => {
        if (!event.target.matches('[data-item]') || !event.target.open) return;
        this.querySelectorAll('[data-item]').forEach(item => { if (item !== event.target) item.open = false; });
      }, {capture:true, signal:this.abort.signal});
      this.renderItems();
      this.hidden = false;
      this.classList.add('is-ready');
      this.initialized = true;
      if (this.config.manualPixel && typeof window.fbq === 'function') {
        window.fbq('track','ViewContent',{content_ids:[String(this.config.productId)],content_type:'product',value:first.price / 100,currency:this.config.currency});
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
    format(value) { return this.money.format(value / 100); }
    image(variant) { return variant.featured_image?.src || this.config.fallbackImage; }
    renderItems() {
      const container = this.querySelector('[data-items]');
      container.replaceChildren();
      for (let index = 0; index < this.quantity; index++) {
        const item = this.querySelector('[data-item-template]').content.firstElementChild.cloneNode(true);
        item.dataset.item = index;
        item.open = index === 0;
        item.querySelector('[data-item-name]').textContent = `${this.copy.item_label} ${index + 1}`;
        for (const variant of this.variants) {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'adv__pearl-grace-builder__color';
          button.dataset.color = variant.id; button.disabled = !variant.available;
          button.setAttribute('aria-label', `${this.copy.item_label} ${index + 1}: ${variant.title}${variant.available ? '' : ` — ${this.copy.sold_out_label}`}`);
          const img = document.createElement('img'); img.src = this.image(variant); img.width = 44; img.height = 44; img.alt = ''; img.loading = 'lazy';
          const name = document.createElement('span'); name.textContent = variant.title;
          button.append(img,name); item.querySelector('[data-colors]').append(button);
        }
        container.append(item); this.updateItem(index);
      }
      this.update();
    }
    updateItem(index) {
      const item = this.querySelector(`[data-item="${index}"]`), variant = this.choices[index];
      item.querySelector('[data-item-image]').src = this.image(variant);
      item.querySelector('[data-item-color]').textContent = variant.title;
      item.querySelectorAll('[data-color]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.color) === variant.id)));
    }
    click(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      if (button.matches('[data-color], [data-group], [data-addon-toggle], [data-remove], [data-submit]')) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (button.hasAttribute('data-color')) {
        const index = Number(button.closest('[data-item]').dataset.item);
        this.choices[index] = this.variants.find(v => v.id === Number(button.dataset.color));
        this.updateItem(index); this.update(); this.syncGallery(this.choices[index]);
      }
      if (button.hasAttribute('data-group')) {
        const open = button.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('[data-group]').forEach(tab => tab.setAttribute('aria-expanded', String(open && tab === button)));
        this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = !open || panel.dataset.panel !== button.dataset.group; });
      }
      if (button.hasAttribute('data-addon-toggle')) this.toggleAddon(button.closest('[data-card]'));
      if (button.hasAttribute('data-remove')) { this.selected.delete(button.dataset.remove); this.updateCards(); this.update(); }
      if (button.hasAttribute('data-submit')) this.submit();
    }
    change(event) {
      const input = event.target;
      if (input.matches('[data-quantity]')) { this.quantity = Number(input.value); this.renderItems(); }
      if (input.matches('[data-addon-variant]')) {
        const card = input.closest('[data-card]'), data = this.addons.get(card.dataset.card);
        const variant = data.variants.find(v => v.id === Number(input.value));
        if (variant) {
          card.querySelector('[data-card-price]').textContent = this.format(variant.price);
          const image = card.querySelector('img');
          if (image && variant.featured_image?.src) { image.src = variant.featured_image.src; image.removeAttribute('srcset'); }
        }
        if (this.selected.has(card.dataset.card)) {
          if (variant?.available) this.selected.set(card.dataset.card, {data,variant});
          else this.selected.delete(card.dataset.card);
        }
        this.updateCards(); this.update();
      }
    }
    toggleAddon(card) {
      const key = card.dataset.card, data = this.addons.get(key);
      if (this.selected.has(key)) this.selected.delete(key);
      else {
        const select = card.querySelector('select');
        if (select && !select.value) { card.querySelector('[data-options]').hidden = false; select.focus(); return; }
        const variant = select ? data.variants.find(v => v.id === Number(select.value)) : data.variants.find(v => v.available);
        if (!variant?.available) return;
        this.selected.set(key, {data,variant});
      }
      this.updateCards(); this.update();
    }
    updateCards() {
      this.querySelectorAll('[data-card]').forEach(card => {
        const button = card.querySelector('[data-addon-toggle]');
        if (!button || button.disabled) return;
        const selected = this.selected.has(card.dataset.card);
        card.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
        button.textContent = selected ? this.copy.added_label : this.copy.add_label;
        button.setAttribute('aria-label', `${button.textContent}: ${this.addons.get(card.dataset.card).title}`);
      });
    }
    update() {
      const pearls = this.choices.slice(0,this.quantity);
      const pearlSubtotal = pearls.reduce((sum,v) => sum + v.price,0);
      const extras = [...this.selected.values()];
      const extrasSubtotal = extras.reduce((sum,item) => sum + item.variant.price,0);
      const eligibleQuantity = (this.config.eligible ? this.quantity : 0) + extras.filter(item => item.data.eligible).length;
      const percent = !this.copy.estimate_discount ? 0 : eligibleQuantity >= 3 ? this.copy.discount_three : eligibleQuantity === 2 ? this.copy.discount_two : 0;
      const eligiblePrices = [...(this.config.eligible ? pearls.map(v => v.price) : []), ...extras.filter(item => item.data.eligible).map(item => item.variant.price)];
      const saving = eligiblePrices.reduce((sum,price) => sum + Math.round(price * percent / 100),0);
      this.total = pearlSubtotal + extrasSubtotal - saving;
      this.querySelector('[data-count]').textContent = `${this.quantity} ${this.quantity === 1 ? this.copy.singular : this.copy.plural}`;
      this.querySelector('[data-pearl-total]').textContent = this.format(pearlSubtotal);
      this.querySelector('[data-extras-row]').hidden = extras.length === 0;
      this.querySelector('[data-extras-total]').textContent = this.format(extrasSubtotal);
      this.querySelector('[data-saving-row]').hidden = saving === 0;
      this.querySelector('[data-saving-label]').textContent = `${this.copy.savings_label} (${percent}%)`;
      this.querySelector('[data-saving]').textContent = `−${this.format(saving)}`;
      this.querySelector('[data-total]').textContent = this.format(this.total);
      this.querySelector('[data-benefit]').textContent = this.config.currency === 'USD' && this.total >= this.copy.shipping_threshold * 100 ? this.copy.shipping_label : '';
      this.querySelector('[data-submit]').textContent = `${this.copy.submit_label} (${this.quantity + extras.length}) — ${this.format(this.total)}`;
      const selected = this.querySelector('[data-selected-items]'); selected.replaceChildren();
      this.querySelector('[data-selected]').hidden = extras.length === 0;
      for (const [key,item] of this.selected) {
        const row = document.createElement('div'); row.className = 'adv__pearl-grace-builder__selected-row';
        const text = document.createElement('span'); text.textContent = `${item.data.title}${item.variant.title === 'Default Title' ? '' : ` · ${item.variant.title}`} — ${this.format(item.variant.price)}`;
        const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.remove = key; remove.textContent = this.copy.remove_label;
        remove.setAttribute('aria-label', `${this.copy.remove_label}: ${item.data.title}`); row.append(text,remove); selected.append(row);
      }
    }
    syncGallery(variant) {
      const region = this.closest('.product-information');
      const slides = [...(region?.querySelectorAll('media-gallery slideshow-component slideshow-slide') || [])];
      const slide = slides.find(node => node.querySelector(`[data-media-id="${this.config.mediaByVariant[variant.id]}"]`));
      if (slide) region.querySelectorAll('media-gallery .slideshow-controls__thumbnail')[slides.indexOf(slide)]?.click();
      const url = new URL(window.location.href); url.searchParams.set('variant',variant.id); history.replaceState(null,'',url);
    }
    async submit() {
      if (this.busy) return;
      this.busy = true;
      const button = this.querySelector('[data-submit]'), status = this.querySelector('[data-status]');
      button.disabled = true; button.textContent = this.copy.adding_label; status.textContent = '';
      this.setAttribute('aria-busy','true');
      const quantities = new Map();
      const extras = [...this.selected].filter(([key]) =>
        this.querySelector(`[data-card="${key}"] [data-addon-toggle]`)?.getAttribute('aria-pressed') === 'true'
      ).map(([,item]) => item);
      const variants = [...this.choices.slice(0,this.quantity), ...extras.map(item => item.variant)];
      for (const variant of variants) quantities.set(variant.id,(quantities.get(variant.id) || 0) + 1);
      const items = [...quantities].map(([id,quantity]) => ({id,quantity}));
      let cartUpdate;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        cartUpdate = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(new CartLinesUpdateEvent({
          action:'add', context:'product',
          lines:items.map(item => ({merchandiseId:String(item.id),quantity:item.quantity})),
          promise:cartUpdate.promise,
        }));
        const response = await fetch(this.config.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.copy.error_label);
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'});
        if (!cartResponse.ok) throw new Error('Added to cart, but the cart could not be refreshed. Please open your cart.');
        const cart = await cartResponse.json();
        cartUpdate.resolve({
          cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail:{source:'pearl-grace-builder',items:cart.items,itemCount:variants.length,didError:false},
        });
        if (this.config.manualPixel && typeof window.fbq === 'function') {
          window.fbq('track','AddToCart',{content_ids:[String(this.config.productId), ...extras.map(item => String(item.data.id))],content_type:'product',value:this.total / 100,currency:this.config.currency,num_items:variants.length});
        }
        this.dispatchEvent(new CustomEvent('caleo:set-added',{bubbles:true,detail:{items:result.items}}));
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'pearl-grace-builder'}}));
        const appPanel = document.getElementById('rapi-cart-drawer-panel');
        const appToggle = document.querySelector('#rapi-cart-drawer-app .rapi-cart-drawer__toggle');
        if (appPanel && appToggle) {
          if (appPanel.hidden) appToggle.click();
        } else {
          const cartTrigger = document.querySelector('header-actions [aria-label="Cart"]');
          if (cartTrigger) cartTrigger.click();
          else status.textContent = 'Your selection has been added to your cart.';
        }
      } catch(error) {
        cartUpdate?.reject(error);
        status.textContent = error.message || this.copy.error_label;
      } finally {
        this.busy = false; button.disabled = false; this.removeAttribute('aria-busy'); this.update();
      }
    }
  }
  if (!customElements.get('pearl-grace-builder')) customElements.define('pearl-grace-builder',PearlGraceBuilder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pg-product-description"] && !Shopify.designMode) return;
  try {
    if (!window.__productDescriptionTextOnlyInit) {
    window.__productDescriptionTextOnlyInit = true;

    const cleanProductDescriptionHtml = (html, showMedia) => {
      const parser = new DOMParser();
      const documentFragment = parser.parseFromString(html, 'text/html');
      const removableElements = showMedia
        ? 'script, style'
        : 'img, picture, video, iframe, model-viewer, script, style';

      documentFragment.querySelectorAll(removableElements).forEach((node) => {
        node.remove();
      });

      documentFragment.querySelectorAll('*').forEach((node) => {
        if (node.tagName === 'P' && !node.textContent.trim()) {
          node.remove();
        }
      });

      return documentFragment.body.innerHTML.trim();
    };

    const hydrateProductDescriptionBlock = async (block) => {
      if (block.dataset.productDescriptionHydrated === 'true') return;

      const endpoint = block.dataset.productDescriptionEndpoint;
      const content = block.querySelector('.text-block');
      const showMedia = block.dataset.showMedia === 'true';

      if (!endpoint || !content) return;

      try {
        const response = await fetch(endpoint, {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;

        const productData = await response.json();
        const cleanedHtml = cleanProductDescriptionHtml(productData.description || '', showMedia);

        if (!cleanedHtml) return;

        content.innerHTML = cleanedHtml;
        block.dataset.productDescriptionHydrated = 'true';
      } catch (error) {
        console.warn('Product description refresh failed', error);
      }
    };

    const initProductDescriptionBlocks = () => {
      document.querySelectorAll('[data-product-description-block]').forEach((block) => {
        hydrateProductDescriptionBlock(block);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductDescriptionBlocks, { once: true });
    } else {
      initProductDescriptionBlocks();
    }

    document.addEventListener('shopify:section:load', initProductDescriptionBlocks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pg-product-trust-stack"] && !Shopify.designMode) return;
  try {
    (function() {
    const countdowns = document.querySelectorAll('[data-pg-local-midnight-countdown]');
    if (!countdowns.length) return;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function getTonightEnd() {
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      return end.getTime();
    }

    for (const countdown of countdowns) {
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');
      if (!hoursEl || !minutesEl || !secondsEl) continue;

      function updateCountdown() {
        const distance = Math.max(getTonightEnd() - Date.now(), 0);
        const hours = Math.floor(distance / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pg-shipping-location"] && !Shopify.designMode) return;
  try {
    class PearlGraceShipping extends HTMLElement {
    connectedCallback() {
      this.renderDispatchDate();
      this.renderCountryFlag();
    }

    renderDispatchDate() {
      const dateElement = this.querySelector('[data-caleo-ship-date]');
      if (!dateElement) return;

      const dispatchDays = Math.max(Number.parseInt(this.dataset.dispatchDays, 10) || 1, 1);
      const skipWeekends = this.dataset.skipWeekends === 'true';
      const dispatchDate = new Date();
      dispatchDate.setHours(12, 0, 0, 0);

      let addedDays = 0;
      while (addedDays < dispatchDays) {
        dispatchDate.setDate(dispatchDate.getDate() + 1);
        const dayOfWeek = dispatchDate.getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

        if (!skipWeekends || !isWeekend) addedDays += 1;
      }

      const locale = document.documentElement.lang || 'en';
      const formatter = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      });

      const year = dispatchDate.getFullYear();
      const month = String(dispatchDate.getMonth() + 1).padStart(2, '0');
      const day = String(dispatchDate.getDate()).padStart(2, '0');

      dateElement.dateTime = `${year}-${month}-${day}`;
      dateElement.textContent = formatter.format(dispatchDate);
    }

    renderCountryFlag() {
      const flagElement = this.querySelector('[data-caleo-country-flag]');
      const countryCode = (this.dataset.countryCode || '').toUpperCase();
      if (!flagElement || !/^[A-Z]{2}$/.test(countryCode)) return;

      flagElement.textContent = [...countryCode]
        .map((character) => String.fromCodePoint(127397 + character.charCodeAt(0)))
        .join('');
    }
  }

  if (!customElements.get('pearl-grace-shipping')) {
    customElements.define('pearl-grace-shipping', PearlGraceShipping);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    if (!window.__productDescriptionTextOnlyInit) {
    window.__productDescriptionTextOnlyInit = true;

    const cleanProductDescriptionHtml = (html, showMedia) => {
      const parser = new DOMParser();
      const documentFragment = parser.parseFromString(html, 'text/html');
      const removableElements = showMedia
        ? 'script, style'
        : 'img, picture, video, iframe, model-viewer, script, style';

      documentFragment.querySelectorAll(removableElements).forEach((node) => {
        node.remove();
      });

      documentFragment.querySelectorAll('*').forEach((node) => {
        if (node.tagName === 'P' && !node.textContent.trim()) {
          node.remove();
        }
      });

      return documentFragment.body.innerHTML.trim();
    };

    const hydrateProductDescriptionBlock = async (block) => {
      if (block.dataset.productDescriptionHydrated === 'true') return;

      const endpoint = block.dataset.productDescriptionEndpoint;
      const content = block.querySelector('.text-block');
      const showMedia = block.dataset.showMedia === 'true';

      if (!endpoint || !content) return;

      try {
        const response = await fetch(endpoint, {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;

        const productData = await response.json();
        const cleanedHtml = cleanProductDescriptionHtml(productData.description || '', showMedia);

        if (!cleanedHtml) return;

        content.innerHTML = cleanedHtml;
        block.dataset.productDescriptionHydrated = 'true';
      } catch (error) {
        console.warn('Product description refresh failed', error);
      }
    };

    const initProductDescriptionBlocks = () => {
      document.querySelectorAll('[data-product-description-block]').forEach((block) => {
        hydrateProductDescriptionBlock(block);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductDescriptionBlocks, { once: true });
    } else {
      initProductDescriptionBlocks();
    }

    document.addEventListener('shopify:section:load', initProductDescriptionBlocks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ravella-product-trust-stack"] && !Shopify.designMode) return;
  try {
    (function() {
    const countdowns = document.querySelectorAll('[data-rav-local-midnight-countdown]');
    if (!countdowns.length) return;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function getTonightEnd() {
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      return end.getTime();
    }

    for (const countdown of countdowns) {
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');
      if (!hoursEl || !minutesEl || !secondsEl) continue;

      function updateCountdown() {
        const distance = Math.max(getTonightEnd() - Date.now(), 0);
        const hours = Math.floor(distance / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
